import React, { PropTypes } from 'react'

import './AliadaProfileVerifications.scss'
import VerificationModal from 'components/InformationModal'

const AliadaProfileVerifications = (props) => {
  const {
    aliada
  } = props

  const showModalWhenDescriptionIsAvailable = (description) => {
    if (description) {
      return (
        <VerificationModal>
          <h3>{description}</h3>
        </VerificationModal>
      )
    }
  }

  const renderVerifications = (verifications) => {
    return verifications.map((verification) => (
      <li key={verification.slug}>
        {verification.name}
        {showModalWhenDescriptionIsAvailable(verification.description)}
      </li>
    ))
  }

  return (
    <div className='AliadaProfileVerifications'>
      <ul className='list-unstyled'>
        {renderVerifications(aliada.verifications)}
      </ul>
    </div>
  )
}
AliadaProfileVerifications.displayName = 'AliadaProfileVerifications'
AliadaProfileVerifications.propTypes = {
  aliada: PropTypes.shape({
    verifications: PropTypes.arrayOf(PropTypes.shape({
      slug: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      description: PropTypes.string
    })).isRequired
  }).isRequired
}

export default AliadaProfileVerifications



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/shared/components/AliadaProfileVerifications/AliadaProfileVerifications.js